import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssignmentForm from '../components/forms/AssignmentForm/AssignmentForm';
import './CreateAssignmentPage.css';

/**
 * CreateAssignmentPage - Standalone page wrapper for AssignmentForm component
 * 
 * This page provides the routing context and navigation logic
 * while delegating all form logic to the AssignmentForm component.
 */
function CreateAssignmentPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // Build prefill from location state
  const prefill = {
    selectedDate: location.state?.selectedDate,
    endeavorId: location.state?.endeavorId,
    eventId: location.state?.eventId
  };

  // Handle cancel - navigate back
  const handleCancel = () => {
    if (location.state?.returnTo) {
      navigate(location.state.returnTo);
    } else {
      navigate('/calendar');
    }
  };

  // Handle success - navigate to assignment detail or returnTo
  const handleSuccess = (createdAssignment) => {
    const normalizedId = createdAssignment?._normalizedId || 
                         createdAssignment?.assignmentId || 
                         createdAssignment?.id || 
                         createdAssignment?.assignment_id;
    
    // Navigate after short delay to show success state
    setTimeout(() => {
      if (location.state?.returnTo) {
        navigate(location.state.returnTo);
      } else if (normalizedId) {
        navigate(`/assignment/${normalizedId}`);
      } else {
        navigate('/calendar');
      }
    }, 1000);
  };

  return (
    <div className="create-assignment-page">
      <div className="page-container">
        <div className="page-header">
          <h1>✨ Create New Assignment</h1>
          <p className="page-subtitle">Add a new assignment to track your coursework</p>
        </div>

        <div className="page-content">
          <AssignmentForm
            prefill={prefill}
            compact={false}
            onCancel={handleCancel}
            onSuccess={handleSuccess}
          />
        </div>
      </div>
    </div>
  );
}

export default CreateAssignmentPage;
